'use client'

import Link from 'next/link'
import React from 'react'

type CTAButtonSize = 'md' | 'lg'
type CTAButtonVariant = 'outline' | 'filled'

interface CTAButtonProps {
  href?: string
  children: React.ReactNode
  size?: CTAButtonSize
  className?: string
  onClick?: () => void
  variant?: CTAButtonVariant
}

const sizeClasses: Record<CTAButtonSize, string> = {
  md: 'min-h-12 px-5 py-3 text-sm',
  lg: 'min-h-13 px-6 py-3.5 text-base sm:px-8'
}

export default function CTAButton({ href, children, size = 'md', className = '', onClick, variant = 'outline' }: CTAButtonProps) {
  const isOutline = variant === 'outline'

  const baseClasses = `portfolio-button inline-flex items-center justify-center whitespace-nowrap rounded-xl font-semibold tracking-[-0.01em] transition duration-200 active:translate-y-px focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-3 focus-visible:outline-[#00E59E] ${sizeClasses[size]} ${className}`
  const outlineClasses = 'border border-white/35 bg-transparent text-white hover:border-[#00E59E] hover:bg-[#00E59E] hover:text-[#1A1D3E]'
  const filledClasses = 'bg-[#00E59E] text-[#1A1D3E] hover:bg-[#19f0ad]'
  const content = <span>{children}</span>

  if (href) {
    return (
      <Link href={href} className={`${baseClasses} ${isOutline ? outlineClasses : filledClasses}`} onClick={onClick}>
        {content}
      </Link>
    )
  }

  return (
    <button className={`${baseClasses} ${isOutline ? outlineClasses : filledClasses}`} onClick={onClick}>
      {content}
    </button>
  )
}

